import { Box, Flex, Image, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import { jewlr_t } from "helpers/application"

const Grid = styled(Box).attrs((props) => ({
  ...(props.inCart
    ? {
        display: "grid",
        gap: { _: "10px 0", tablet: "10px" },
        gridTemplateColumns: { _: "1fr 1fr", tablet: "repeat(4, 1fr)" },
        mb: { tablet: "12px" },
      }
    : {
        alignItems: "center",
        display: { _: "flex", tablet: "grid" },
        flexDirection: "column",
        gap: { _: "20px", tablet: 0 },
        gridTemplateColumns: "repeat(5, 1fr)",
        pb: { _: "10px", tablet: "12px" },
      }),
}))``

const StepBox = styled(Flex).attrs((props) => ({
  alignItems: "center",
  ...(props.inCart
    ? {
        flexDirection: "column",
        gap: 2,
        px: { _: "12px", tablet: "18px" },
      }
    : {
        flexDirection: { tablet: "column" },
        gap: "12px",
        px: { tablet: "12px" },
      }),
}))``

const InnerBox = styled(Box).attrs((props) => ({
  ...(!props.inCart && {
    alignItems: "center",
    display: { _: "flex", tablet: "block" },
    gap: 1,
  }),
}))``

const StepIcon = styled(Box)`
  align-items: center;
  background-color: ${(props) => props.theme.colors.black};
  border-radius: 50%;
  color: ${(props) => props.theme.colors.white};
  display: flex;
  font-size: 16px;
  font-weight: 700;
  height: 26px;
  justify-content: center;
  line-height: 26px;
  margin: auto;
  width: 26px;
`

const getSteps = (inCart) => [
  ...(inCart
    ? [
        {
          description:
            "Create your Instant Gift video below and place your order.",
          icon: "personalize",
        },
      ]
    : [
        {
          description: `${jewlr_t(
            "terms.Personalize"
          )} a unique gift and add it to the cart.`,
          icon: "personalize",
        },
        {
          description: "In cart, create your Instant Gift and place order.",
          icon: "create",
        },
      ]),
  {
    description: inCart
      ? "Preview your video from the Confirmation Page or Email."
      : "Preview your video from the order confirmation.",
    icon: "preview",
  },
  {
    description: inCart
      ? "Share your video via WhatsApp, text, email or Messenger."
      : "Share your Instant Gift video via text or email.",
    icon: "share",
  },
  {
    description: inCart
      ? `We handcraft and ${jewlr_t(
          "terms.ship"
        )} your gift – it arrives a few days later.`
      : "We craft your custom order – it arrives in days.",
    icon: "craft",
  },
]

const HowItWorks = ({ inCart }) => (
  <Grid inCart={inCart}>
    {getSteps(inCart).map((step, i) => (
      <StepBox inCart={inCart} key={i}>
        <Image
          alt={step.description}
          height={inCart ? "80px" : { _: "60px", tablet: "80px" }}
          src={require(`images/instant-gifts/explained/${step.icon}.svg`)}
          width={inCart ? "80px" : { _: "60px", tablet: "80px" }}
        />
        <InnerBox inCart={inCart}>
          <StepIcon>{i + 1}</StepIcon>
          <Typography
            color="grey.65"
            fontSize="16px"
            py={1}
            {...(!inCart && {
              textAlign: { _: "left", tablet: "center" },
              width: { _: "211px", tablet: "100%" },
            })}
          >
            {step.description}
          </Typography>
        </InnerBox>
      </StepBox>
    ))}
  </Grid>
)

HowItWorks.propTypes = {
  inCart: PropTypes.bool,
}

export default HowItWorks
